import { render, staticRenderFns } from "./TagDeleteConfirmDialog.vue?vue&type=template&id=dddec152&scoped=true&"
import script from "./TagDeleteConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./TagDeleteConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./TagDeleteConfirmDialog.vue?vue&type=style&index=0&id=dddec152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddec152",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src904045295/src/ueyes-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dddec152')) {
      api.createRecord('dddec152', component.options)
    } else {
      api.reload('dddec152', component.options)
    }
    module.hot.accept("./TagDeleteConfirmDialog.vue?vue&type=template&id=dddec152&scoped=true&", function () {
      api.rerender('dddec152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/TagDeleteConfirmDialog.vue"
export default component.exports